import { styled } from 'components/ThemeConfigConnector/ThemeConfigConnnector';
import { Breakpoints, MQ } from 'style/styled-components/cssMediaQueries';

interface OverlayContainerProps {
    visible: boolean;
    position: 'left' | 'right' | 'center';
    fadeInDuration: number;
    fadeOutDuration: number;
}

const edgeAlignedPosition = (side: 'left' | 'right') => `
    ${side}: 16px;
    transform: translateY(-50%);

    ${MQ(Breakpoints.s)} {
        ${side}: 44px;
    }

    ${MQ(Breakpoints.m)} {
        ${side}: 72px;
    }
`;

export const OverlayContainer = styled.div<OverlayContainerProps>`
    position: absolute;
    top: 50%;
    opacity: ${(props) => (props.visible ? 1 : 0)};
    transition: opacity ${(props) => (props.visible ? `${props.fadeInDuration}ms ease-in` : `${props.fadeOutDuration}ms ease-out`)};
    z-index: 999;
    pointer-events: none;

    ${({ position }) => {
        switch (position) {
            case 'left':
                return edgeAlignedPosition('left');
            case 'right':
                return edgeAlignedPosition('right');
            default:
                return `
                    left: 50%;
                    transform: translate(-50%, -50%);
                `;
        }
    }}
`;

export const IconWrapper = styled.div`
    width: 80px;
    height: 80px;

    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
`;

export const JumpIconWrapper = styled.div`
    position: relative;
    width: 48px;
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const PlaybackIconWrapper = styled.div`
    width: 80px;
    height: 80px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    background: color-mix(in srgb, var(--color-dark-background), transparent 30%);

    .SVGInline-svg {
        width: 48px;
        height: 48px;
        display: block;
    }
`;
